<template>
  <div class="heum-work">
    <div class="heum-work__item">
      <div class="heum-work__photo">
        <img src="~/assets/images/heum-people/heum-work01-new.jpg" alt="" />
      </div>
      <div class="heum-work__contents">
        <div class="heum-work__title">
          120여 명의 세무 전문가가<br />
          기장부터 경영 자문까지 분야별로 책임집니다
        </div>
        <p class="heum-work__text">
          세무도 각 분야별 전문가에게 자문을 구하는 것이 가장 정확합니다. 혜움은
          세무기장, 경정청구, 조세불복, 세무조사 대응 등 각 분야별 전문가들이 한
          팀으로 협업해 최적의 해결책을 제공하고 있습니다.
        </p>
      </div>
    </div>
    <div class="heum-work__item heum-work__item--reverse">
      <div class="heum-work__photo">
        <img src="~/assets/images/heum-people/heum-work02-new.jpg" alt="" />
      </div>
      <div class="heum-work__contents">
        <div class="heum-work__title">
          세무 교육기관인<br />
          혜움 아카데미에서<br />
          전문가를 양성합니다
        </div>
        <p class="heum-work__text">
          사람이 챙겨야 할 게 많은 세무 서비스에서 직원의 전문 역량은 무엇보다
          중요합니다. 혜움은 자체 교육기관인 혜움 아카데미를 설립해 최신 업무
          지식과 업무 기술, 영업, 고객관리 등 체계적인 커리큘럼으로 전문가를
          양성하고 교육하고 있습니다.
        </p>
      </div>
    </div>
    <div class="heum-work__item">
      <div class="heum-work__photo">
        <img src="~/assets/images/heum-people/heum-work03-new.jpg" alt="" />
      </div>
      <div class="heum-work__contents">
        <div class="heum-work__title">
          자체 IT 연구소 (주) 혜움을 운영,<br />
          최고 수준의 IT 전문가들이 함께합니다
        </div>
        <p class="heum-work__text">
          세무법인 혜움의 기술을 책임지는 (주) 혜움은 중소벤처기업부 선정
          아기유니콘 기업, 유수의 투자사로부터 70억 투자 유치 등에 성공하며
          기술력과 가능성을 입증받았습니다. 누구에게나 쉽고 편리한 세무를
          만듭니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.heum-work {
  padding: 3rem 1rem;

  &__item {
    margin-bottom: 3rem;
    word-break: keep-all;
    @include clearfix;

    &--reverse {
      @include av-mq(lap-and-up) {
        .heum-work__photo {
          float: left;
          margin-left: 0;
          margin-right: 4rem;
        }
      }
    }
  }

  &__contents {
    @include av-mq(lap-and-up) {
      float: left;
      width: calc(50% - 4rem);
      padding: 3rem 0 0 0;
    }
  }

  &__photo {
    margin-bottom: 3rem;

    @include av-mq(lap-and-up) {
      max-width: 50%;
      float: right;
      margin-left: 4rem;
      margin-right: 0;
      margin-bottom: 0.5rem;
    }

    img {
      max-width: 100%;
    }
  }

  &__title {
    position: relative;
    margin-bottom: 1rem;
    font-size: 26px;
    line-height: 1.48;
    color: #323438;

    &:before {
      content: '';
      position: absolute;
      top: -1rem;
      display: block;
      width: 32px;
      height: 3px;
      background-color: #1f75e8;
    }

    @include av-mq(lap-and-up) {
      font-size: 32px;
    }
  }

  &__text {
    font-size: 16px;
    line-height: 1.48;
    color: #323438;

    @include av-mq(lap-and-up) {
      font-size: 18px;
    }
  }
}
</style>
